import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Wallet, CheckCircle2, Clock } from "lucide-react";

const GOLD = "#C9953D";
const NAVY = "#0E1D2D";

export default function WalletTopupSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState("pending");
  const [amount, setAmount] = useState(null);

  useEffect(() => {
    if (!sessionId) return;
    let stop = false;
    let tries = 0;
    const check = async () => {
      tries += 1;
      try {
        const r = await api.get(`/billing/wallet/topup/status/${sessionId}`);
        if (!stop) {
          setStatus(r.data?.payment_status || "pending");
          if (r.data?.amount_cents) setAmount(r.data.amount_cents / 100);
        }
        if (!stop && r.data?.payment_status !== "paid" && tries < 30) setTimeout(check, 4000);
      } catch { /* ignore */ }
    };
    check();
    return () => { stop = true; };
  }, [sessionId]);

  const paid = status === "paid";

  return (
    <div className="min-h-screen flex items-center justify-center px-6 py-12" data-testid="wallet-topup-success-page">
      <div className="max-w-lg w-full bg-white rounded-2xl shadow-xl border border-[#E7E5E2] p-8">
        <div className="text-[11px] uppercase tracking-[0.24em] font-semibold mb-3" style={{ color: GOLD }}>HERMES · CARTEIRA</div>
        <div className="flex items-center gap-3 mb-2">
          {paid ? (
            <CheckCircle2 className="w-10 h-10 text-emerald-600" data-testid="topup-icon-success"/>
          ) : (
            <Clock className="w-10 h-10 text-amber-500 animate-pulse" data-testid="topup-icon-pending"/>
          )}
          <h1 className="font-serif text-3xl" style={{ color: NAVY }}>
            {paid ? "Recarga confirmada" : "Aguardando confirmação"}
          </h1>
        </div>
        <p className="text-slate-500 text-sm mb-6">
          {paid
            ? "Seus créditos já foram adicionados à Carteira Hermes."
            : "Estamos confirmando seu pagamento com o Stripe. Isso pode levar alguns segundos."}
        </p>
        {amount != null && (
          <div className="rounded-xl bg-slate-50 border border-[#E7E5E2] p-4 mb-6">
            <div className="text-[10px] uppercase tracking-widest text-slate-500">Valor da recarga</div>
            <div className="font-serif text-3xl mt-1 tabular-nums" style={{ color: NAVY }}>
              {amount.toLocaleString("pt-BR", { style: "currency", currency: "BRL" })}
            </div>
          </div>
        )}
        <Link to="/dashboard" className="w-full h-11 rounded-lg text-white text-[13px] font-semibold inline-flex items-center justify-center gap-2"
          style={{ background: NAVY }} data-testid="topup-back-dashboard">
          <Wallet className="w-4 h-4"/> Ir para o Painel
        </Link>
      </div>
    </div>
  );
}
